import $ from 'jquery';
import ga from 'ga';
import globalScope from 'core/globalScope';
import 'jquery.cookie';
import 'remodal';

/** Modale de confirmation de candidature apr�s postuler 1 clic
 * Si vou�e � �tre r�utilis�e/reprise pour autre chose, penser � en faire une modale de confirmation g�n�rique **/
const CE_CONFIRMATION_CANDIDATURE_COOKIE_NAME = 'CeStopDisplayApplicationConfirm',
  modaleConfirmationCandidature = $('.js-lightbox-confirmation-candidature').remodal(),
  checboxNePlusAfficher = $('.js-checkbox-stop-display-modale-confirmation-candidature');

export default function(postulerCallBack, page) {
  const labelForEvent = page === 'LISTE' ? 'liste' : (page === 'DETAIL_CANDIDATURE' ? 'detail_candidature' : 'dashboard');

  if ($.cookie(CE_CONFIRMATION_CANDIDATURE_COOKIE_NAME) === 'true') {
    postulerCallBack();
  } else {
    modaleConfirmationCandidature.open();
    ga.sendNonInteractiveEvent(
      'navigation',
      `affichage_${labelForEvent}_postuler_1clic_confirmation`,
      `affichage_${labelForEvent}_postuler_1clic_confirmation`
    );

    $(globalScope.document).on('confirmation', '.js-lightbox-confirmation-candidature', () => {
      if (checboxNePlusAfficher.is(':checked')) {
        $.cookie(CE_CONFIRMATION_CANDIDATURE_COOKIE_NAME, 'true', { expires: 30, path: '/' });
        ga.sendEvent(
          'navigation',
          `clic_${labelForEvent}_postuler_1clic_confirmation_stop`,
          `clic_${labelForEvent}_postuler_1clic_confirmation_stop`
        );
      }

      postulerCallBack();
      ga.sendEvent('navigation', `clic_${labelForEvent}_postuler_1clic_confirmation`, 'valider');

      // Pour unbind les events afin de ne pas les trigger encore � la prochaine ouverture de la modale
      $(globalScope.document).off('confirmation', '.js-lightbox-confirmation-candidature');
      $(globalScope.document).off('closed', '.js-lightbox-confirmation-candidature');
    });

    $(globalScope.document).on('closed', '.js-lightbox-confirmation-candidature', () => {
      ga.sendEvent('navigation', `clic_${labelForEvent}_postuler_1clic_confirmation`, 'annuler');

      checboxNePlusAfficher.prop('checked', false);

      // Pour unbind les events afin de ne pas les trigger encore � la prochaine ouverture de la modale
      $(globalScope.document).off('confirmation', '.js-lightbox-confirmation-candidature');
      $(globalScope.document).off('closed', '.js-lightbox-confirmation-candidature');
    });
  }
}
